import React, { useEffect } from 'react'
import * as myconst from "../../constants/index"
import { RadioButton } from "primereact/radiobutton";
import { Controller, useFormContext } from 'react-hook-form';
import { MultiSelect } from 'primereact/multiselect';
import { Checkbox } from 'primereact/checkbox';

interface arr_type {
  value: string;
  label: string;
}

const StepFour = ({ handlePrev, handleNext, goOnFirst, isLinear, goOnLast, methods, setErrorSteps }: any) => {
  const { register, getValues, setValue, watch, formState: { errors }, control, trigger, clearErrors } = useFormContext();
  const getFormErrorMessage = (name: string) => {
    return (
      errors[name] && (
        <small className="p-error">{errors[name]?.message?.toString()}</small>
      )
    )
  }

  const finalError = Object.keys(errors).length
  useEffect(() => {
    setErrorSteps(Object.keys(errors).map((keys: string) => (myconst.findStepWhichAreIncomplete(keys))).filter((item, index) => Object.keys(errors).map((keys: string) => (myconst.findStepWhichAreIncomplete(keys))).indexOf(item) === index))
  }, [finalError])

  const handleNextButton = async () => {
    let isValid: boolean = false;
    isValid = await trigger(['platform_preference', 'content_format', 'multichannel_strategy']);

    if (isValid) {
      handleNext();
    } else {
      const errorFields = Object.keys(errors);
      if (errorFields.length > 0) {
        const errorField = errorFields[0];
        const fieldElement = document.querySelector(`input[name=${errorField}]`);
        if (fieldElement) {
          (fieldElement as HTMLElement)?.focus();
        } else {
          console.warn(`Field with name ${errorField} not found`);
        }
      }
    }
  }

  return (
    <div className='step-preview-wrap'>
      <div className='stepper-main_butter_pie'>
        <div className='stepper-form'>
          <div className='stepper-wrapper'>
            <div className='form-row'>
              <div className='form-col'>
                <label className="form-label fw-bold">Where do you want to create content?</label>
                <Controller
                  name="platform_preference"
                  control={methods.control}
                  rules={{ required: "Please select a topic" }}
                  render={({ field: { value, onChange } }) => (
                    <>
                      {myconst.getCheckboxOptions('platform_preference').map((option: arr_type) => {
                        // Check if the current option is selected
                        // Ensure value is an array
                        const currentValue = Array.isArray(value) ? value : [];
                        // Check if the current option is selected
                        const isChecked = currentValue.includes(option.value);

                        // Toggle the option in the array
                        const toggleOption = () => {
                          clearErrors("platform_preference");
                          let updated = [...currentValue];
                          if (updated.includes(option.value)) {
                            updated = updated.filter((v) => v !== option.value);
                          } else {
                            updated.push(option.value);
                          }
                          onChange(updated);
                        };

                        return (
                          <div key={option.value} className="p-field-checkbox">
                            <Checkbox
                              inputId={'platform_preference'}
                              value={option.value}
                              checked={isChecked}
                              onChange={(e) => {
                                clearErrors('platform_preference')
                                // If checked, add the value to the array; otherwise, remove it
                                let updated = [...value];
                                if (e.checked) {
                                  updated.push(option.value);
                                } else {
                                  updated = updated.filter((v) => v !== option.value);
                                }
                                onChange(updated);
                              }}
                            />
                            <label className="ms-2 c-pointer" onClick={toggleOption} htmlFor={option.value} style={{ marginLeft: "0.5rem" }}>
                              {option.label}
                            </label>
                          </div>
                        );
                      })}
                    </>
                  )}
                />
                {getFormErrorMessage("platform_preference")}
              </div>
            </div>
            <div className='form-row'>
              <div className='form-col'>
                <label className="form-label fw-bold">Do you prefer long-form or short-form content?</label>
                <Controller
                  name="content_format"
                  control={methods.control}
                  rules={{ required: "Please select a content format" }}
                  render={({ field }) => (
                    <>
                      {myconst.getRadioOptions('content_format').map((option: arr_type) => (
                        <div
                          key={option.value}
                          className="p-field-radiobutton"
                        >
                          <RadioButton
                            inputId={'content_format'}
                            value={option.value}
                            onChange={(e) => { field.onChange(e.value); clearErrors('content_format') }}
                            checked={field.value === option.value}
                          />
                          <label className="ms-2 c-pointer" onClick={() => { field.onChange(option.value); clearErrors('content_format') }} htmlFor={option.value}>{option.label}</label>
                        </div>
                      ))}
                    </>
                  )}
                />
                {getFormErrorMessage("content_format")}
              </div>
            </div>
            <div className='form-row'>
              <div className='form-col'>
                <label className="form-label fw-bold">Are you open to multichannel growth or focusing on just one platform?</label>
                <Controller
                  name="multichannel_strategy"
                  control={methods.control}
                  rules={{ required: "Please select a category" }}
                  render={({ field }) => (
                    <>
                      {myconst.getRadioOptions('multichannel_strategy').map((option: arr_type) => (
                        <div
                          key={option.value}
                          className="p-field-radiobutton"
                        >
                          <RadioButton
                            inputId={'multichannel_strategy'}
                            value={option.value}
                            onChange={(e) => { field.onChange(e.value); clearErrors('multichannel_strategy') }}
                            checked={field.value === option.value}
                          />
                          <label className="ms-2 c-pointer" onClick={() => { field.onChange(option.value); clearErrors('multichannel_strategy') }} htmlFor={option.value}>{option.label}</label>
                        </div>
                      ))}
                    </>
                  )}
                />
                {getFormErrorMessage("multichannel_strategy")}
              </div>
            </div>
          </div>
        </div>
        <div className='stepper-footer'>
          <div className='stepper-wrapper stepper-wrapper-ft ms-auto'>
            <div className='stepper-footer-inner'>
              <div className='stepper-footer-left'>
                <button type="button" onClick={goOnFirst} className="grey-outline-btn mr-2">{'<< First'}</button>
                <button type="button" onClick={handlePrev} className="outline-active-btn">{'< Previous'}</button>
              </div>
              <div className='stepper-footer-right'>
                <button type="button" className="outline-active-btn mr-2" onClick={handleNextButton}>{'Next >'}</button>
                <button type="button" disabled={!isLinear} className="grey-outline-btn" onClick={goOnLast}>{'Last >>'}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StepFour